import { useState, useLayoutEffect } from "react";

export function useSearchParams() {
  const [searchParams, setSearchParams] = useState<Record<string, string>>({});

  useLayoutEffect(() => {
    const params = new URLSearchParams(window.location.search);
    const paramsObj: Record<string, string> = {};
    params.forEach((value, key) => {
      paramsObj[key] = value;
    });
    setSearchParams(paramsObj);
  }, []);

  return searchParams;
}
